import $ from 'jquery';

(function () {
    let files;

    function sound_play(sound) {
        let audio = new Audio("res/sound/" + sound + ".mp3");

        audio.play();
    }

    let instanse = false;
    let help_id = $('.support').data('id');
    var state;

    if (!help_id) return;

    function chatScroll() {
        document.querySelector('.chat').scrollTop = $('.chat').get(0).scrollHeight;
    }

    chatScroll();

    function state() {
        if (!instanse) {
            instanse = true;
            $.ajax({
                type: "POST",
                url: "js/handler/help",
                data:
                    {
                        'action': 'state',
                        'help_id': help_id
                    },
                dataType: "json",
                success: function (data) {
                    state = data.state;
                    instanse = false;
                }
            });
        }
    }

    function update() {
        if (!instanse) {
            instanse = true;
            $.ajax({
                type: "POST",
                url: "js/handler/help",
                data:
                    {
                        'action': 'update',
                        'state': state,
                        'help_id': help_id
                    },
                dataType: "json",
                success: function (data) {
                    let new_data = false;

                    for (let i = 0; i < data.text.length; i++) {
                        $('.chat').append(data.text[i]);

                        new_data = true;
                    }

                    if (new_data) {
                        chatScroll();
                    }

                    if (data.outside && new_data) {
                        sound_play("link");
                    }

                    instanse = false;
                    state = data.state;
                }
            });
        } else {
            setTimeout(update, 1500);
        }
    }

    function send(message) {
        let send_data = new FormData();

        $.each(files, function (key, value) {
            send_data.append(key, value);
        });

        send_data.append('action', 'send');
        send_data.append('help_id', help_id);
        send_data.append('message', message);

        $('#chat-send').attr('disabled', 'disabled');
        $('#chat-send span').text('Отправка...');

        $.ajax({
            type: "POST",
            url: "js/handler/help",
            data: send_data,
            cache: false,
            processData: false,
            contentType: false,
            dataType: 'json',
            success: function (data) {
                update();
                $('#chat-file').val('');
                chatScroll()
                chatScroll();
                $('.file-selection__loading').hide();
                $('.file-selection__name').text('');
            },
            error: function () {
                $('.file-selection__loading').hide();
                $('#chat-file').val('');
                $('.file-selection__name').text('');
            },
            complete: function () {
                $('#chat-send').removeAttr('disabled');
                $('#chat-send span').text('Отправить');
            }
        });
    }

    $(function () {
        $("#chat-field").css('visibility', 'visible');
        state();

        $('#chat-file').change(function (e) {
            files = this.files;
        });


        $('#chat-input').keypress(function (e) {
            if (e.keyCode === 10 || e.keyCode === 13) {
                e.preventDefault();
                let text = $(this).val();
                $(this).val('');
                if (text.length > 0 || typeof files != 'undefined') {
                    send(text);
                }
            }
        });

        $('.support__form').on('submit', function (e) {
            e.preventDefault();
            let text = $('#chat-input').val();

            if (text.length > 0 || typeof files != 'undefined') {
                $('#chat-input').val('');
                $('#chat-input').focus();
                send(text);
            } else {
                $('#chat-input').focus();
            }
        });

        setInterval(update, 1000);
    });
})();
